import { createFileRoute } from '@tanstack/react-router';
import { PositionsModule } from '@/modules/position';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/position')({
  component: PositionsModule,
});
